













































































































import { defineComponent, PropType, ref, watch } from '@vue/composition-api'
import { mask } from 'vue-the-mask'
import { getAgencies } from '~/api/Agency/agency.api'
import {
  carCategoryController,
  carSeasonsController,
  shareCarContract,
} from '~/api/RentalCar'
import Autocomplete from '~/components/Autocomplete.vue'
import CreateDialog from '~/components/CreateDialog.vue'
import IconButton from '~/components/IconButton.vue'
import TextButton from '~/components/TextButton.vue'
import { message } from '~/store/modules/notifications'
import { VueForm } from '~/utils/interfaces'
import { CarContract } from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { IconButton, Autocomplete, CreateDialog, TextButton },
  props: {
    item: {
      type: Object as PropType<CarContract>,
      required: true,
    },
  },
  directives: {
    mask,
  },
  setup(props, { root: { $store, $i18n } }) {
    const model = ref(false)
    const loading = ref(false)
    const form = ref<VueForm>()
    const defaultCrud = {
      agency: '',
      prices: [
        {
          min_days: 1,
          max_days: '',
          cost: '',
          season: '',
          category: '',
        },
      ],
    }
    const crud = ref(JSON.parse(JSON.stringify(defaultCrud)))
    const onSuccess = async () => {
      if (!form.value?.validate()) return
      try {
        loading.value = true
        await shareCarContract(props.item.uuid, crud.value)
        model.value = false
        crud.value = JSON.parse(JSON.stringify(defaultCrud))
        form.value?.resetValidation()
        $store.commit('notifications/displayMessage', {
          text: $i18n.t('contract_shared'),
          title: $i18n.t('contract_shared'),
          color: 'primary',
          icon: 'mdi-check-circle',
          description: $i18n.t('contract_shared_successfullu'),
        } as message)
      } finally {
        loading.value = false
      }
    }
    const addContractPrice = () => {
      crud.value.prices.push({
        ...{
          min_days: 1,
          max_days: '',
          cost: '',
          season: '',
          category: '',
        },
      })
    }

    watch(model, v => {
      if (v) {
        crud.value = JSON.parse(JSON.stringify(defaultCrud))
        form.value?.resetValidation()
      }
    })

    return {
      addContractPrice,
      crud,
      form,
      getAgencies,
      getCarCategories: carCategoryController.getter,
      getCarSeason: carSeasonsController.getter,
      loading,
      model,
      onSuccess,
      vRules,
    }
  },
})
